// list of the course
export const ADMIN_ALL_COURSE_LIST_REQUEST = "ADMIN_ALL_COURSE_LIST_REQUEST";
export const ADMIN_ALL_COURSE_LIST_SUCCESS = "ADMIN_ALL_COURSE_LIST_SUCCESS";
export const ADMIN_ALL_COURSE_LIST_FAIL = "ADMIN_ALL_COURSE_LIST_FAIL";

// Home Courses
export const ALL_COURSE_LIST_REQUEST = "ALL_COURSE_LIST_REQUEST";
export const ALL_COURSE_LIST_SUCCESS = "ALL_COURSE_LIST_SUCCESS";
export const ALL_COURSE_LIST_FAIL = "ALL_COURSE_LIST_FAIL";

// getting a specific course for home page
export const HOME_SINGLE_COURSE_REQUEST = "HOME_SINGLE_COURSE_REQUEST";
export const HOME_SINGLE_COURSE_SUCCESS = "HOME_SINGLE_COURSE_SUCCESS";
export const HOME_SINGLE_COURSE_FAIL = "HOME_SINGLE_COURSE_FAIL";
export const SINGLE_COURSE_REVIEWS = "SINGLE_COURSE_REVIEWS";

// course search papge
export const SEARCH_COURSE_PAGE_REQUEST = "SEARCH_COURSE_PAGE_REQUEST";
export const SEARCH_COURSE_PAGE_SUCCESS = "SEARCH_COURSE_PAGE_SUCCESS";
export const SEARCH_COURSE_PAGE_FAIL = "SEARCH_COURSE_PAGE_FAIL";

// filter courses data
export const FILTER_COURSE_DATA_REQUEST = "FILTER_COURSE_DATA_REQUEST";
export const FILTER_COURSE_DATA_SUCCESS = "FILTER_COURSE_DATA_SUCCESS";
export const FILTER_COURSE_DATA_FAIL = "FILTER_COURSE_DATA_FAIL";
export const FILTER_COURSE_DATA_RESET = "FILTER_COURSE_DATA_RESET";

// getting a specific course
export const GET_SINGLE_COURSE_REQUEST = "GET_SINGLE_COURSE_REQUEST";
export const GET_SINGLE_COURSE_SUCCESS = "GET_SINGLE_COURSE_SUCCESS";
export const GET_SINGLE_COURSE_FAIL = "GET_SINGLE_COURSE_FAIL";

// user courses list
export const MY_USER_COURSES_LIST_REQUEST = "MY_USER_COURSES_LIST_REQUEST";
export const MY_USER_COURSES_LIST_SUCCESS = "MY_USER_COURSES_LIST_SUCCESS";
export const MY_USER_COURSES_LIST_FAIL = "MY_USER_COURSES_LIST_FAIL";

export const GET_ALL_CATEGORIES_REQUEST = "GET_ALL_CATEGORIES_REQUEST";
export const GET_ALL_CATEGORIES_SUCCESS = "GET_ALL_CATEGORIES_SUCCESS";

export const CLEAR_COURSE_ERRORS = "CLEAR_COURSE_ERRORS";
export const HOME_CLEAR_COURSE_ERRORS = "HOME_CLEAR_COURSE_ERRORS";
